<script lang="ts">
	import Button from "../atoms/Button.svelte";
	import { ErrorService } from "../services/error.service";

	export let klass= ""
	export let previous = () => {
		ErrorService.unimplemented()
	}
	export let next = () => {
		ErrorService.unimplemented()
	}
	export let result = 0
	export let page = 1
	export let max = 10

	$: currentMax = result < max || page * max >= result ? result : page * max
</script>

<div class={klass}>
	<div class="text-sm text-gray-500">
		<span class="font-medium">{result}</span> 件中
		<span class="font-medium">{(page - 1) * max + 1}</span> -
		<span class="font-medium">{currentMax}</span> 件
	</div>

	{#if result / max !== 0 && page !== 1}
		<Button
			click={previous}
			text="text-gray-500"
			border=""
			rounded
		>
			前へ
		</Button>
	{/if}

	{#if result / max !== 0 && page < result / max}
		<Button
			click={next}
			text="text-gray-500"
			border=""
			rounded
		>
			次へ
		</Button>
	{/if}
</div>

<style lang="postcss">
</style>